import React from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import { getMeters, login } from "../../services";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { setAccessToken, updateUserInfo ,updateUserMeters} from "../../redux/action";

const LoginComponent = () => {
  const dispatch = useDispatch();

  const validations = yup.object().shape({
    email: yup.string().email("email not valid").required("email is required"),
    password: yup.string().required("password is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validations,
    onSubmit: (data) => {
      login(data).then((response) =>{
        const {data} = response;
        dispatch(setAccessToken(data.accessToken));
        dispatch(updateUserInfo({name:data.name,id:data.id}));
        getMeters().then((meterResponse) =>{
          dispatch(updateUserMeters(meterResponse.data));
        });
      });
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  return (
    <div className="w-100">
      <form onSubmit={formik.handleSubmit} className="p-fluid">
        <div className="field mt-4 mb-3">
          <span className=" p-input-icon-right">
            <i className="pi pi-envelope" />
            <InputText
              id="email"
              name="email"
              placeholder="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className={classNames({ "p-invalid": isFormFieldValid("email") })}
            />
          </span>
          {getFormErrorMessage("email")}
        </div>
        <div className="field">
          <span>
            <Password
              id="password"
              name="password"
              autoComplete="on"
              feedback={false}
              value={formik.values.password}
              placeholder="Password"
              onChange={formik.handleChange}
              toggleMask
              className={classNames({
                "p-invalid": isFormFieldValid("password"),
              })}
            />
          </span>
          {getFormErrorMessage("password")}
        </div>
        <Button type="submit" label="Submit" className="submit" />
      </form>
    </div>
  );
};

export default LoginComponent;
